<template lang="html">
  <div class="transfer-customers">
    <div class="content-i">
      <div class="content-box" style="padding-top: 10px;">
        <div class="element-wrapper">
          <h6 class="element-header">{{ t('titleTransferCustomer','titleTransferCustomer') }}</h6>
          <div class="element-box">
            <div class="element-info">
              <div class="row">
                <div class="col-12 col-sm-6 col-md-8">
                  <div class="element-info-with-icon">
                    <div class="element-info-icon">
                      <fontAwesomeIcon :icon="['fa', 'people-arrows']" class="text-primary mr-2" size="1x"/>
                    </div>
                    <div class="element-info-text">
                      <h5 class="element-inner-header">{{ t('titleTransferCustomer','titleTransferCustomer') }}</h5>
                      <div class="element-inner-desc">{{ t('descTransferCustomer','descTransferCustomer') }}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="element-box-tp">
              <b-form v-on:submit.prevent="transferCustomer">
                <b-form-group
                  class="col-sm-12 col-md-6 col-lg-3"
                  label-for="source-ref"
                  :description="t('descSourceCustomerReference', 'descSourceCustomerReference')"
                  :label="'* ' + t('sourceCustomerReference', 'sourceCustomerReference')" >
                  <b-form-input
                    id="source-ref"
                    v-model="customerTransfer.refSource"
                    required
                    :placeholder="t('sourceCustomerReference', 'sourceCustomerReference')"
                  ></b-form-input>
                </b-form-group>

                <b-form-group
                  class="col-sm-12 col-md-6 col-lg-3"
                  label-for="target-ref"
                  :description="t('descTargetCustomerReference', 'descTargetCustomerReference')"
                  :label="'* ' + t('targetCustomerReference', 'targetCustomerReference')" >
                  <b-form-input
                    id="target-ref"
                    v-model="customerTransfer.refTarget"
                    required
                    :placeholder="t('targetCustomerReference', 'targetCustomerReference')"
                  ></b-form-input>
                </b-form-group>

                <b-form-group
                  class="mx-2"
                  label-for="copy-details"
                  :description="t('descCopyCustomerDetails', 'descCopyCustomerDetails')"
                  >
                  <b-form-checkbox id="copy-details" v-model="customerTransfer.copyDetails">{{t('copyCustomerDetails', 'copyCustomerDetails')}}</b-form-checkbox>
                </b-form-group>

                <b-form-group
                  class="mx-2"
                  label-for="move-documents"
                  :description="t('descMoveDocuments', 'descMoveDocuments')"
                  >
                  <b-form-checkbox id="move-documents" v-model="customerTransfer.moveDocuments">{{t('moveDocuments', 'moveDocuments')}}</b-form-checkbox>
                </b-form-group>

                <b-form-group
                  class="mx-2"
                  label-for="move-users"
                  :description="t('descMoveUsers', 'descMoveUsers')"
                  >
                  <b-form-checkbox id="move-users" v-model="customerTransfer.moveUsers">{{t('moveUsers', 'moveUsers')}}</b-form-checkbox>
                </b-form-group>

                <b-form-group
                  class="mx-2"
                  label-for="delete-source"
                  :description="t('descDeleteSourceCustomer', 'descDeleteSourceCustomer')"
                  >
                  <b-form-checkbox id="delete-source" v-model="customerTransfer.delSourceCustomer">{{t('delSourceCustomer', 'delSourceCustomer')}}</b-form-checkbox>
                </b-form-group>

               <transition name="fade">
                 <ResponseInfo v-if="(getResponseInfo.status == 'error') && (getResponseInfo.responseName == 'transferCustomer')" class="mt-3"/>
               </transition>
                <div class="d-flex justify-content-end">
                  <b-button class="mx-2" type="submit" variant="primary" :disabled="canSubmit">{{t('buttonStartTransfer', 'buttonStartTransfer')}}</b-button>
                </div>
              </b-form>
            </div>
          </div>
        </div>
      </div>
    </div>
    <b-modal ref="customerTransferSuccess-modal" id="customerTransferSuccess" :title="t('modalTitleTransferCustomerSuccess','modalTitleTransferCustomerSuccess')" :header-bg-variant="'secondary'" no-close-on-esc no-close-on-backdrop hide-backdrop>
      <template slot="modal-header" slot-scope="{ close }">
        <h5 class="modal-title text-light"><fontAwesomeIcon :icon="['fas', 'user-check']" size="1x" class="mr-2"/> {{ t('modalTitleTransferCustomerSuccess','modalTitleTransferCustomerSuccess') }}</h5>
        <button aria-label="Close" class="close" data-dismiss="modal" type="button" @click="close(); hideModal();"><span aria-hidden="true" class="text-light">X</span></button>
      </template>
      <template slot="default" slot-scope="{ close }">
        <h5 class="text-center text-primary">{{t('customerTransferReport', 'customerTransferReport')}}</h5>
        <template v-for="reportLine in getResponseInfo.responseData['success']">
          <p class="report-list-elem" v-if="reportLine.success_code == 'target_created'">
            <fontAwesomeIcon :icon="['fa', 'check']" class="text-success mr-2"/>
            {{ t(reportLine.labels[0], reportLine.labels[0]) }} {{ reportLine.variables[0] }} {{ t(reportLine.labels[1], reportLine.labels[1]) }}
          </p>
          <p class="report-list-elem" v-if="reportLine.success_code == 'source_transferred'">
            <fontAwesomeIcon :icon="['fa', 'check']" class="text-success mr-2"/>
            {{ t(reportLine.labels[0], reportLine.labels[0]) }} {{ reportLine.variables[0] }} {{ t(reportLine.labels[1], reportLine.labels[1]) }}
          </p>
          <p class="report-list-elem" v-if="reportLine.success_code == 'source_document_transferred'">
            <fontAwesomeIcon :icon="['fa', 'check']" class="text-success mr-2"/>
            {{ t(reportLine.labels[0], reportLine.labels[0]) }} ({{ reportLine.variables[0] }}) {{ t(reportLine.labels[1], reportLine.labels[1]) }} ({{ reportLine.variables[1] }}) {{ t(reportLine.labels[2], reportLine.labels[2]) }}
          </p>
          <p class="report-list-elem" v-if="reportLine.success_code == 'source_user_transferred'">
            <fontAwesomeIcon :icon="['fa', 'check']" class="text-success mr-2"/>
            {{ t(reportLine.labels[0], reportLine.labels[0]) }} ({{ reportLine.variables[0] }}) {{ t(reportLine.labels[1], reportLine.labels[1]) }} {{ reportLine.variables[1] }} {{ t(reportLine.labels[2], reportLine.labels[2]) }}
          </p>
          <p class="report-list-elem" v-if="reportLine.success_code == 'source_account_retired'">
            <fontAwesomeIcon :icon="['fa', 'check']" class="text-success mr-2"/>
            {{ t(reportLine.labels[0], reportLine.labels[0]) }} ({{ reportLine.variables[0] }}) {{ t(reportLine.labels[1], reportLine.labels[1]) }}
          </p>
          <p class="report-list-elem" v-if="reportLine.success_code == 'source_deleted'">
            <fontAwesomeIcon :icon="['fa', 'check']" class="text-success mr-2"/>
            {{ t(reportLine.labels[0], reportLine.labels[0]) }} ({{ reportLine.variables[0] }}) {{ t(reportLine.labels[1], reportLine.labels[1]) }}
          </p>
          <p class="report-list-elem" v-if="reportLine.success_code == 'customer_transfer'">
            <fontAwesomeIcon :icon="['fa', 'check']" class="text-success mr-2"/>
            {{ t(reportLine.labels[0], reportLine.labels[0]) }} {{ reportLine.variables[0] }} {{ t(reportLine.labels[1], reportLine.labels[1]) }} {{ reportLine.variables[1] }} {{ t(reportLine.labels[2], reportLine.labels[2]) }}
          </p>
        </template>
      </template>
      <template slot="modal-footer" slot-scope="{ close }">
        <!--
          <button aria-label="downloadCSV" class="btn btn-primary" type="button" :disabled="canDownloadCSV" @click="downloadCustomerTransferCSV()">
            <fontAwesomeIcon :icon="['fa', 'file-download']" class="text-light mr-2"/> {{ t('buttonDownloadCSV', 'buttonDownloadCSV')}}
          </button>-->
          <button aria-label="Close" data-dismiss="modal" class="btn btn-secondary" type="button" @click="close(); hideModal();">
            <fontAwesomeIcon :icon="['fa', 'times']" class="text-light mr-2"/>{{ t('buttonClose', 'buttonClose')}}
          </button>
      </template>
    </b-modal>
    <div v-if="showModal" class="modal-backdrop show"></div>
  </div>
</template>

<script>
import Navbar from '@/components/Navbar'
import ResponseInfo from '@/components/ResponseInfo.vue'
import { mapGetters } from 'vuex'

export default {
  name: 'transfer_customers',
  components:{
    ResponseInfo
  },
  data() {
    return {
      customerTransfer: {
        copyDetails: true,
        moveDocuments: true,
        moveUsers: true,
        delSourceCustomer: true
      },
      isBusy: false,
      showModal: false
    }
  },
  computed:{
    ...mapGetters(['getResponseInfo']),
    canSubmit() {
      if(this.customerTransfer.refSource && this.customerTransfer.refTarget) {
        return false
      } else {
        return true
      }
    },
    /*
    canDownloadCSV() {
      let transferReport = this.$store.getters['customerStore/getTransferReport']
      if((transferReport == undefined) || (transferReport == null)) {
        return true
      } else {
        return false
      }
    }*/
  },
  methods:{
    transferCustomer() {
      this.isBusy = true
      this.$store.dispatch('customerStore/transferCustomer', this.customerTransfer)
      .then(() => {
        this.isBusy = false
        let responseStatus = this.getResponseInfo.status
        if(responseStatus != 'error'){
          this.showModal = true
          this.$refs['customerTransferSuccess-modal'].show()
        }
      })
    },
    hideModal() {
      this.showModal = false
    },
    /*
    downloadCustomerTransferCSV() {
      this.isBusy = true
      let transferReport = this.$store.getters['customerStore/getTransferReport']
      if((transferReport != undefined) || (transferReport != null)) {
          this.$store.dispatch('customerStore/downloadCustomerTransferSuccessCSV', transferReport)
          .then(() => {

          })
      }
      this.isBusy = false
    }*/
  }
}
</script>

<style lang="css" scoped>
.report-list-elem{

}
.modal-open #customerTransferSuccess___BV_modal_outer_ >>> .modal-dialog{
  display: flex !important;
  justify-content: center !important;
}
.modal-open #customerTransferSuccess___BV_modal_outer_ >>> .modal-content{
  min-width: 750px !important;
  max-width: auto !important;
  width: auto !important;
}
.modal-open #customerTransferSuccess___BV_modal_outer_ >>> .modal-content .modal-body{
  max-height: 520px;
  overflow-y: scroll;
}

</style>
